import React from "react";
import "./DataSwitcher.css";

function DataSwitcher({ selectedPeriod, onPeriodChange }) {
  const periods = [
    { id: "annual", label: "Annual" },
    { id: "dec-jan-feb", label: "Dec-Jan-Feb" },
    { id: "mar-apr-may", label: "Mar-Apr-May" },
    { id: "jun-jul-aug", label: "Jun-Jul-Aug" },
    { id: "sep-oct-nov", label: "Sep-Oct-Nov" },
  ];

  return (
    <div className="data-switcher">
      {periods.map((period) => (
        <button
          key={period.id}
          className={`period-btn ${selectedPeriod === period.id ? "selected" : ""}`}
          onClick={() => onPeriodChange(period.id)}
        >
          {period.label}
        </button>
      ))}
    </div>
  );
}

export default DataSwitcher;

